export default {
  cities: 'المدن',
  city: 'المدينة',
  add: 'إضافة مدينة',
  update: 'تعديل المدينة',
  details: 'تفاصيل المدينة'
}
